import React, { createContext, ReactNode, useContext, useState } from "react";
import NewPasswordProvider from "./NewPasswordProvider";
import ShowToast from "../../../../widget/common/ui/Toast";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import StorageKeys from "../../../../const/StorageKeys";
import SessionStorage from "../../../../service/storage/SessionStorage";
import { AlertMesage } from "../../../../widget/common/ui/Alerts";
import { SignupResult } from "../../../../model/onboarding/signup/SignupModel";

type NewPasswordTypes = {
  passwords: NewPasswordFeldsTypes;
  validateStatus: boolean;
  processing: boolean;
  passwordsValidate: PasswordValidateFeldsTypes;
  handleOnChange: (
    name: string,
    value: string,
    isValid: boolean | undefined
  ) => void;
  submitPassword: () => void;
};

type NewPasswordFeldsTypes = {
  password: string;
  password_confirm: string;
};

type PasswordValidateFeldsTypes = {
  password: boolean;
  confirm: boolean;
};

const NewPasswordContext = createContext<NewPasswordTypes | undefined>(
  undefined
);

export const NewPasswordContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [processing, setProcessing] = useState<boolean>(false);
  const [validateStatus, setValidateStatus] = useState<boolean>(false);
  const [passwords, setPasswords] = useState<NewPasswordFeldsTypes>({
    password: "",
    password_confirm: "",
  });

  const [passwordsValidate, setPasswordsValidate] =
    useState<PasswordValidateFeldsTypes>({ password: false, confirm: false });

  const handleOnChange = (
    fieldName: string,
    fieldValue: string,
    isValid: boolean | undefined
  ) => {
    fieldName = fieldName.toLowerCase();
    let passwordsTemp = { ...passwords },
      passwordsValidateTemp = { ...passwordsValidate };

    if (fieldName === `new_password`) {
      passwordsTemp = { ...passwordsTemp, password: fieldValue };
      passwordsValidateTemp = {
        ...passwordsValidateTemp,
        password: isValid ?? true,
      };
    } else if (fieldName === `password_confirm`) {
      passwordsTemp = { ...passwordsTemp, password_confirm: fieldValue };
      passwordsValidateTemp = {
        ...passwordsValidateTemp,
        confirm: isValid ?? true,
      };
    }

    setValidateStatus(false);
    setPasswords(passwordsTemp);
    setPasswordsValidate(passwordsValidateTemp);
  };

  const submitPassword = async () => {
    setValidateStatus(true);
    const recoverSession = SessionStorage.getValue(
      StorageKeys.recover_password_detail
    );
    if (UtilityHelper.isNotEmpty(recoverSession)) {
      if (passwordsValidate.password && passwordsValidate.confirm) {
        if (passwords.password === passwords.password_confirm) {
          const recoverSessionValues: SignupResult = JSON.parse(recoverSession);

          setProcessing(true);
          const statusResponse = await NewPasswordProvider.submitPasswordAPI({
            profileId: recoverSessionValues.account_id!,
            resetCode: recoverSessionValues.verif_code!,
            password: passwords.password,
          });
          setProcessing(false);

          if (statusResponse) {
            AlertMesage({
              title: "your_password_changed_successfully",
              onClick: () => {
                NewPasswordProvider.navigateLogin();
              },
            });
          } else {
            ShowToast.error(AppTranslation.text("something_went_wrong"));
          }
        } else {
          ShowToast.info(AppTranslation.text("password_mismatch"));
        }
      }
    }
  };

  return (
    <NewPasswordContext.Provider
      value={{
        passwords,
        validateStatus,
        processing,
        passwordsValidate,
        submitPassword,
        handleOnChange,
      }}
    >
      {children}
    </NewPasswordContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const NewPasswordContextImport = () => {
  const context = useContext(NewPasswordContext);
  if (!context) {
    throw new Error(
      "NewPasswordContextImport must be used within a NewPasswordContextProvider"
    );
  }
  return context;
};
